import { render } from "./SorryZipCodeFooter.vue?vue&type=template&id=10dda312&scoped=true"
import script from "./SorryZipCodeFooter.vue?vue&type=script&lang=js"
export * from "./SorryZipCodeFooter.vue?vue&type=script&lang=js"

import "./SorryZipCodeFooter.vue?vue&type=style&index=0&id=10dda312&lang=css"
import "./SorryZipCodeFooter.vue?vue&type=style&index=1&id=10dda312&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10dda312"]])

export default __exports__